import React, { useState } from 'react'
import { Box, Stack } from '@mui/material'
import { BreakdownDialog } from './BreakdownDialog'
import { BreakdownButton } from './BreakdownButton'
import { DetailRow } from './DetailRow'

export const CompanyBreakdown = ({ companyName = '', pointBreakdown = [] }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Stack direction='row' spacing={1} alignItems='center'>
        <BreakdownButton
          label='View company details'
          value={companyName}
          onClick={() => setOpen(true)}
        />
      </Stack>
      <BreakdownDialog open={open} title='Company Breakdown' onClose={() => setOpen(false)}>
        {pointBreakdown.map((item, index) => (
          <Box sx={{ mb: 1.5 }} key={index}>
            <DetailRow label='HTG Company' value={item.htgCompany} />
            <DetailRow label='Company ID' value={item.companyAccountId} />
            <DetailRow label='Company Name' value={item.companyName} />
            <DetailRow label='Price Group' value={item.priceGroup} />
            <DetailRow label='Sales' value={item.salesId} />
            <DetailRow label='Point' value={item.point} />
          </Box>
        ))}
      </BreakdownDialog>
    </>
  )
}
